import ArrowRightBlackIcon from 'assets/ver2/icons/arrow-right-black.svg';
import ArrowRightWhiteIcon from 'assets/ver2/icons/arrow-right-white.svg';
import EventNavIconActive from 'assets/ver2/icons/event-nav-icon-active.svg';
import ExchangeIcon from 'assets/ver2/icons/icon_exchange.svg';
import RemittanceIcon from 'assets/ver2/icons/icon_remittance.svg';
import NotificationsNavIconActive from 'assets/ver2/icons/notification-nav-icon-active.svg';
import OfferIcon from 'assets/ver2/icons/offer-sidebar-icon.svg';
import PersonalInfoActiveNavIcon from 'assets/ver2/icons/personal-info-icon-active.svg';
import PromotionNavIconActive from 'assets/ver2/icons/promotion-nav-icon-active.svg';
import ReceiptIcon from 'assets/ver2/icons/receipt-icon.svg';
import ReceiversBusinessIconActive from 'assets/ver2/icons/receiver_business.svg';
import ReceiversIndividualIconActive from 'assets/ver2/icons/receiver_personal.svg';
import SecurityNavIconActive from 'assets/ver2/icons/security-nav-icon-active.svg';
import ReferralNavIconActive from 'assets/ver2/icons/share-nav-icon-active.svg';
import TodaysRateIcon from 'assets/ver2/icons/todays-rate-icon.svg';
import UsersIcon from 'assets/ver2/icons/users-icon.svg';
import VoucherNavIconActive from 'assets/ver2/icons/voucher-nav-icon-active.svg';
import NotifyBadge from 'components/Profile/components/ProfileBody/NotifyBadge';

import {
  DASHBOARD_PREFIX,
  FX_DASHBOARD_PREFIX,
  FX_TRANSACTIONS_PREFIX,
  NOTIFICATIONS_PREFIX,
  OFFERS_PREFIX,
  PROFILE_PREFIX,
  PROMOTIONS_EVENTS_PREFIX,
  PROMOTIONS_PREFIX,
  RECEIVERS_PREFIX,
  REFERRAL_PREFIX,
  SECURITY_PREFIX,
  TRANSACTIONS_PREFIX,
} from 'constants/router';

export const REMITTANCE_TITLE = {
  text: 'transactions_nav_label',
  icon: RemittanceIcon,
};

export const REMITTANCE_NAV = [
  {
    text: 'label_side_remittance_today_rate',
    icon: TodaysRateIcon,
    iconActive: TodaysRateIcon,
    href: `${DASHBOARD_PREFIX}`,
  },
  {
    text: 'label_side_remittance_transactions',
    icon: ReceiptIcon,
    iconActive: ReceiptIcon,
    href: `${TRANSACTIONS_PREFIX}`,
  },
];

export const REMITTANCE_MOBILE_NAV = [
  {
    text: 'label_side_remittance_today_rate_mobile',
    href: `${DASHBOARD_PREFIX}`,
  },
  {
    text: 'label_side_remittance_transactions',
    href: `${TRANSACTIONS_PREFIX}`,
  },
  {
    text: 'label_side_remittance_receivers',
    href: `${RECEIVERS_PREFIX}`,
  },
];

export const RECEIVERS_TITLE = {
  text: 'label_side_remittance_receivers',
  icon: UsersIcon,
  iconActive: UsersIcon,
  href: `${RECEIVERS_PREFIX}`,
};

export const RECEIVERS_SUB_MENU = [
  {
    text: 'label_individual_receiver',
    icon: ReceiversIndividualIconActive,
    iconActive: ReceiversIndividualIconActive,
    arrow: ArrowRightBlackIcon,
    arrowActive: ArrowRightWhiteIcon,
    href: '',
  },
  {
    text: 'label_business_receiver',
    icon: ReceiversBusinessIconActive,
    iconActive: ReceiversBusinessIconActive,
    arrow: ArrowRightBlackIcon,
    arrowActive: ArrowRightWhiteIcon,
    href: '',
  },
];

export const EXCHANGE_TITLE = {
  text: 'fx_nav_label',
  icon: ExchangeIcon,
};

export const EXCHANGE_NAV = [
  {
    text: 'label_side_exchange_rate',
    icon: TodaysRateIcon,
    iconActive: TodaysRateIcon,
    href: `${FX_DASHBOARD_PREFIX}`,
  },
  {
    text: 'label_side_exchange_transactions',
    icon: ReceiptIcon,
    iconActive: ReceiptIcon,
    href: `${FX_TRANSACTIONS_PREFIX}`,
  },
];

export const OFFER_TITLE = {
  text: 'offer_nav_label',
  icon: OfferIcon,
};

export const OFFER_NAV = [
  {
    text: 'label_offers_vouchers',
    label: 'label_offers_vouchers',
    icon: VoucherNavIconActive,
    iconActive: VoucherNavIconActive,
    href: `${OFFERS_PREFIX}`,
  },
  {
    text: 'label_offers_promotions',
    label: 'label_offers_promotions',
    icon: PromotionNavIconActive,
    iconActive: PromotionNavIconActive,
    href: `${PROMOTIONS_PREFIX}`,
  },
  {
    text: 'label_offers_events',
    label: 'label_offers_events',
    icon: EventNavIconActive,
    iconActive: EventNavIconActive,
    href: `${PROMOTIONS_EVENTS_PREFIX}`,
  },
];

export const PROFILE_TITLE = {
  text: 'profile_title',
  icon: RemittanceIcon,
};
export const PROFILE_NAV = [
  {
    text: 'label_personal_information',
    label: 'label_personal_information',
    icon: PersonalInfoActiveNavIcon,
    iconActive: PersonalInfoActiveNavIcon,
    href: `${PROFILE_PREFIX}`,
  },
  {
    text: 'label_security',
    label: 'label_security',
    icon: SecurityNavIconActive,
    iconActive: SecurityNavIconActive,
    href: `${SECURITY_PREFIX}`,
  },
  {
    text: 'label_notifications',
    label: 'label_notifications',
    icon: NotificationsNavIconActive,
    iconActive: NotificationsNavIconActive,
    href: `${NOTIFICATIONS_PREFIX}`,
    Badge: (props) => <NotifyBadge {...props} />,
  },
  {
    text: 'label_referral',
    label: 'label_referral',
    icon: ReferralNavIconActive,
    iconActive: ReferralNavIconActive,
    href: `${REFERRAL_PREFIX}`,
  },
];

export const REFERRAL_CONTENT_TABS_LABEL = [
  {
    label: 'label_referral_tab_1',
  },
  {
    label: 'label_referral_tab_2',
  },
];
